// extracted by mini-css-extract-plugin
export default {"container":"RegisterInput_container__xMVW9","touched":"RegisterInput_touched__Qv2hu","valid":"RegisterInput_valid__B5Y2w","warning":"RegisterInput_warning__BK5Tr"};